import { createContext } from "react";
import { BaseClient, ClientsState } from "./types.js";

export const getApiClientsContext = <Client extends BaseClient, StaffClient extends BaseClient>() => {
    return createContext<ClientsState<Client, StaffClient>>({ clients: [], staffClients: [] });
};
